import { Card, Table } from "react-bootstrap";
import useCallApi from "../../../hooks/useCallApi";
import moment from "moment";
import { colors } from '../../../theme/variables'
import Loading from '../../../templates/UI/Loading/Loading'
import { DropdownItem } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dollars from "../../../templates/Dollars/Dollars";
import { useEffect, useState } from "react";
import callAPI from "../../../helpers/callAPI";

const Margin = () => {
    const [init, setInit] = useState(true)

    const [data, setData] = useState()
    const [dataLoaded, setDataLoaded] = useState(false)

    const fetchData = async () => {
        setDataLoaded(false)
        let result = await callAPI(`mbStatus/monitoring/margin`, 'GET')
        if (result.success) {
            setData(result)
        }
        setDataLoaded(true)
    }

    useEffect(() => {
        if (init) {
            fetchData()
            setInit(false)
        }
        const interval = setInterval(() => {
            fetchData()
        }, 60000)
        return () => clearInterval(interval)
    }, [])
    return (
        <Card className="mb-3">
            <Card.Header>Margin</Card.Header>
            <Card.Body>
                {dataLoaded && data ? (
                <Table className="m-0">
                    <thead>
                        <tr>
                            <th>Day</th>
                            <th>Projected</th>
                            <th>MTD Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><Dollars value={data.details.todayMargin} /></td>
                            <td><Dollars value={data.details.projectedDailyMargin} /></td>
                            <td><Dollars value={data.details.monthlyMargin} /></td>
                        </tr>
                    </tbody>
                </Table>
                ) : (
                    <Loading />
                )}
            </Card.Body>
        </Card>
    )
}

export { Margin }